export default __webpack_public_path__ + "static/media/Token Transparent (2).951cb2df.png";